module.exports = __webpack_public_path__ + "img/icon-face-mobile.a9d82ed1.png";